const routes = [
  {
    path: 'defensivecss',
    name: 'defensivecss',
    component: () => import(/* webpackChunkName: "defensivecss" */ '@/modules/defensivecss/index.vue')
  },
];

export default routes;